/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationPreferenceSettingDeliveryScope } from './NotificationPreferenceSettingDeliveryScope';
import {
    NotificationPreferenceSettingDeliveryScopeFromJSON,
    NotificationPreferenceSettingDeliveryScopeFromJSONTyped,
    NotificationPreferenceSettingDeliveryScopeToJSON,
    NotificationPreferenceSettingDeliveryScopeToJSONTyped,
} from './NotificationPreferenceSettingDeliveryScope';

/**
 * 
 * @export
 * @interface NotificationPreferenceSettings
 */
export interface NotificationPreferenceSettings {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    notification_preference_id?: string;
    /**
     * 
     */
    user_id?: string;
    /**
     * 
     */
    batch_enabled?: boolean;
    /**
     * 
     */
    batch_window?: string | null;
    /**
     * 
     */
    delivery_scopes?: Array<NotificationPreferenceSettingDeliveryScope>;
}

/**
 * Check if a given object implements the NotificationPreferenceSettings interface.
 */
export function instanceOfNotificationPreferenceSettings(value: object): value is NotificationPreferenceSettings {
    return true;
}

export function NotificationPreferenceSettingsFromJSON(json: any): NotificationPreferenceSettings {
    return NotificationPreferenceSettingsFromJSONTyped(json, false);
}

export function NotificationPreferenceSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'notification_preference_id': json['notification_preference_id'] == null ? undefined : json['notification_preference_id'],
        'user_id': json['user_id'] == null ? undefined : json['user_id'],
        'batch_enabled': json['batch_enabled'] == null ? undefined : json['batch_enabled'],
        'batch_window': json['batch_window'] === undefined ? undefined : json['batch_window'] === null ? null : json['batch_window'],
        'delivery_scopes': json['delivery_scopes'] == null ? undefined : ((json['delivery_scopes'] as Array<any>).map(NotificationPreferenceSettingDeliveryScopeFromJSON)),
    };
}

export function NotificationPreferenceSettingsToJSON(json: any): NotificationPreferenceSettings {
    return NotificationPreferenceSettingsToJSONTyped(json, false);
}

export function NotificationPreferenceSettingsToJSONTyped(value?: NotificationPreferenceSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'notification_preference_id': value['notification_preference_id'],
        'user_id': value['user_id'],
        'batch_enabled': value['batch_enabled'],
        'batch_window': value['batch_window'],
        'delivery_scopes': value['delivery_scopes'] == null ? undefined : ((value['delivery_scopes'] as Array<any>).map(NotificationPreferenceSettingDeliveryScopeToJSON)),
    };
}

